// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"1843":"polyfills-css-shim","2214":"polyfills-core-js","6748":"polyfills-dom","8592":"common"}[chunkId] || chunkId) + ".js";
};